"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTrailingAmountFieldInForm = exports.isTimeInForceFieldInForm = exports.isStopPriceFieldInForm = exports.isPegPriceFieldInForm = exports.isLimitPriceFieldInForm = exports.isLimitOffsetFieldInForm = exports.isDisplayQuantityFieldInForm = exports.getPegPriceByType = exports.getOrderTypeByName = exports.getOrderEventSnackbar = exports.getFormValuesForSubmittingOrder = void 0;
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _orderEntryFormConstants = require("../constants/sendOrder/orderEntryFormConstants");
var _orderFormTypes = require("../constants/sendOrder/orderFormTypes");
var _timeInForceConstants = require("../constants/sendOrder/timeInForceConstants");
var _pegPriceTypeConstants = require("../constants/sendOrder/pegPriceTypeConstants");
var _numberFormatter = require("./numberFormatter");
var _config = _interopRequireDefault(require("../config"));
var _buySellSelectors = require("../redux/selectors/buySellSelectors");
var _selectors = require("../redux/margin/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getFormValuesForSubmittingOrder = exports.getFormValuesForSubmittingOrder = function getFormValuesForSubmittingOrder(orderFormType, options) {
  var instrument = options.instrument,
    userInfo = options.userInfo,
    selectedAccountId = options.selectedAccountId,
    state = options.state;
  var baseOptions = {
    InstrumentId: instrument.selectedInstrumentId,
    OMSId: userInfo.OMSId,
    AccountId: selectedAccountId,
    TimeInForce: 1,
    ClientOrderId: 0,
    OrderIdOCO: 0,
    UseDisplayQuantity: false
  };
  if ((0, _selectors.isMarginActiveSelector)(state)) {
    var leverage = (0, _selectors.currentLeverageSelector)(state);
    baseOptions.Leverage = 1 / (leverage - 1);
  }
  if (orderFormType === _orderFormTypes.orderFormTypes["default"]) {
    return getFormValuesForDefaultForm(baseOptions, options);
  } else if (orderFormType === _orderFormTypes.orderFormTypes.advanced) {
    return getFormValuesForAdvancedForm(baseOptions, options);
  } else if (orderFormType === _orderFormTypes.orderFormTypes.block) {
    return getFormValuesForReportBlockTradeForm(baseOptions, options);
  } else if (orderFormType === _orderFormTypes.orderFormTypes.buySell) {
    return getFormValuesForBuySellForm(baseOptions, options);
  } else {
    console.error("order form type ".concat(orderFormType, " does not exists"));
    return {};
  }
};
var getOrderEventSnackbar = exports.getOrderEventSnackbar = function getOrderEventSnackbar(order) {
  var type, text, textVars;
  var isCancelled = order.OrderState === 'Canceled';
  if (['Working', 'FullyExecuted'].some(function (i) {
    return order.OrderState === i;
  })) {
    // t('Your order has been successfully added')
    text = 'Your order has been successfully added';
    type = 'success';
  } else if (order.OrderState === 'Rejected' || isCancelled) {
    if (order.RejectReason || order.CancelReason || order.ChangeReason) {
      text = order.RejectReason || order.CancelReason || order.ChangeReason;
      type = 'warning';
    } else {
      // t('Your Order has been {{n}}')
      text = 'Your Order has been {{n}}';
      textVars = {
        n: order.OrderState
      };
      type = isCancelled ? 'success' : 'warning';
    }
  }
  return {
    type: type,
    text: text,
    textVars: textVars
  };
};
var isLimitPriceFieldInForm = exports.isLimitPriceFieldInForm = function isLimitPriceFieldInForm(orderType) {
  return [_orderEntryFormConstants.orderTypes.limit.displayName, _orderEntryFormConstants.orderTypes.stopLimit.displayName, _orderEntryFormConstants.orderTypes.fillOrKill.displayName, _orderEntryFormConstants.orderTypes.immediateOrCancel.displayName, _orderEntryFormConstants.orderTypes.reserveOrder.displayName].some(function (i) {
    return i === orderType;
  });
};
var isTimeInForceFieldInForm = exports.isTimeInForceFieldInForm = function isTimeInForceFieldInForm(orderType) {
  return [_orderEntryFormConstants.orderTypes.limit.displayName, _orderEntryFormConstants.orderTypes.stopLimit.displayName, _orderEntryFormConstants.orderTypes.trailingStopLimit.displayName].some(function (i) {
    return i === orderType;
  });
};
var isStopPriceFieldInForm = exports.isStopPriceFieldInForm = function isStopPriceFieldInForm(orderType) {
  return [_orderEntryFormConstants.orderTypes.stopMarket.displayName, _orderEntryFormConstants.orderTypes.stopLimit.displayName].some(function (i) {
    return i === orderType;
  });
};
var isLimitOffsetFieldInForm = exports.isLimitOffsetFieldInForm = function isLimitOffsetFieldInForm(orderType) {
  return [_orderEntryFormConstants.orderTypes.trailingStopLimit.displayName].some(function (i) {
    return i === orderType;
  });
};
var isDisplayQuantityFieldInForm = exports.isDisplayQuantityFieldInForm = function isDisplayQuantityFieldInForm(orderType) {
  return [_orderEntryFormConstants.orderTypes.reserveOrder.displayName].some(function (i) {
    return i === orderType;
  });
};
var isTrailingAmountFieldInForm = exports.isTrailingAmountFieldInForm = function isTrailingAmountFieldInForm(orderType) {
  return [_orderEntryFormConstants.orderTypes.trailingStopLimit.displayName, _orderEntryFormConstants.orderTypes.trailingStopMarket.displayName].some(function (i) {
    return i === orderType;
  });
};
var isPegPriceFieldInForm = exports.isPegPriceFieldInForm = function isPegPriceFieldInForm(orderType) {
  return [_orderEntryFormConstants.orderTypes.trailingStopLimit.displayName, _orderEntryFormConstants.orderTypes.trailingStopMarket.displayName].some(function (i) {
    return i === orderType;
  });
};
var getOrderTypeByName = exports.getOrderTypeByName = function getOrderTypeByName(displayName) {
  var key = Object.keys(_orderEntryFormConstants.orderTypes).find(function (key) {
    return _orderEntryFormConstants.orderTypes[key].displayName === displayName;
  });
  return _orderEntryFormConstants.orderTypes[key].orderType;
};
var getFormValuesForDefaultForm = function getFormValuesForDefaultForm(baseOptions, options) {
  var form = options.form;
  var formValues = form;
  var defaultForm = _objectSpread(_objectSpread({}, baseOptions), {}, {
    Side: Number(formValues.side),
    OrderType: Number(getOrderTypeByName(formValues.orderType)),
    PegPriceType: getPegPriceTypeBySide(formValues.side)
  });
  if (formValues.anchoredField === 'value') {
    defaultForm.Value = _typeof(formValues.value) === 'object' ? formValues.value.toNumber() : formValues.value;
  }
  if (formValues.quantity) {
    defaultForm.Quantity = _bignumber["default"].isBigNumber(formValues.quantity) ? formValues.quantity.toFormat(options.quantityDecimalPlaces, {
      decimalSeparator: '.',
      groupSeparator: ''
    }) : formValues.quantity.toFixed(options.quantityDecimalPlaces);
  }
  if (isLimitPriceFieldInForm(formValues.orderType)) {
    defaultForm.LimitPrice = formValues.limitPrice;
    if (_typeof(defaultForm.LimitPrice) === 'object') {
      defaultForm.LimitPrice = formValues.limitPrice.toNumber();
    }
  }
  if (isTimeInForceFieldInForm(formValues.orderType)) {
    defaultForm.TimeInForce = Number(formValues.timeInForce);
  }
  if (isStopPriceFieldInForm(formValues.orderType)) {
    defaultForm.StopPrice = formValues.stopPrice;
  }
  return defaultForm;
};
var getFormValuesForAdvancedForm = function getFormValuesForAdvancedForm(baseOptions, options) {
  var form = options.form;
  var formValues = form;
  var advancedForm = _objectSpread(_objectSpread({}, baseOptions), {}, {
    Side: Number(formValues.side),
    Quantity: formValues.quantity,
    OrderType: Number(getOrderTypeByName(formValues.orderType)),
    TimeInForce: getTimeInForceValue(formValues.orderType),
    PegPriceType: getPegPriceTypeBySide(formValues.side)
  });
  if (formValues.anchoredField === 'value') {
    advancedForm.Value = _typeof(formValues.value) === 'object' ? formValues.value.toNumber() : formValues.value;
  }
  if (formValues.quantity) {
    advancedForm.Quantity = _bignumber["default"].isBigNumber(formValues.quantity) ? formValues.quantity.toFormat(options.quantityDecimalPlaces, {
      decimalSeparator: '.',
      groupSeparator: ''
    }) : formValues.quantity.toFixed(options.quantityDecimalPlaces);
  }
  if (isLimitPriceFieldInForm(formValues.orderType)) {
    advancedForm.LimitPrice = formValues.limitPrice;
    if (_typeof(advancedForm.LimitPrice) === 'object') {
      advancedForm.LimitPrice = formValues.limitPrice.toNumber();
    }
  }
  if (isTimeInForceFieldInForm(formValues.orderType)) {
    advancedForm.TimeInForce = Number(formValues.timeInForce);
  }
  if (isStopPriceFieldInForm(formValues.orderType)) {
    advancedForm.StopPrice = formValues.stopPrice;
  }
  if (isTrailingAmountFieldInForm(formValues.orderType)) {
    advancedForm.TrailingAmount = formValues.trailingAmount;
    if (_typeof(advancedForm.TrailingAmount) === 'object') {
      advancedForm.TrailingAmount = formValues.trailingAmount.toNumber();
    }
  }
  if (isPegPriceFieldInForm(formValues.orderType)) {
    advancedForm.PegPriceType = formValues.pegPriceType;
  }
  if (isDisplayQuantityFieldInForm(formValues.orderType)) {
    advancedForm.DisplayQuantity = formValues.displayQuantity;
    advancedForm.UseDisplayQuantity = true;
  }
  if (isLimitOffsetFieldInForm(formValues.orderType)) {
    advancedForm.LimitOffset = formValues.limitOffset;
    if (_typeof(advancedForm.LimitOffset) === 'object') {
      advancedForm.LimitOffset = formValues.limitOffset.toNumber();
    }
  }
  return advancedForm;
};
var getFormValuesForReportBlockTradeForm = function getFormValuesForReportBlockTradeForm(baseOptions, options) {
  var form = options.form;
  var formValues = form;
  var price = new _bignumber["default"](formValues.price);
  var quantity = new _bignumber["default"](formValues.quantity);
  var LimitPrice = price.toFixed(options.priceDecimalPlaces).toString();
  if (!options.useNewForm) {
    LimitPrice = price.div(quantity).toFixed(options.priceDecimalPlaces).toString();
  }
  return {
    LimitPrice: LimitPrice,
    InstrumentId: baseOptions.InstrumentId,
    AccountId: baseOptions.AccountId,
    Side: parseInt(formValues.side, 10),
    counterPartyId: formValues.counterparty.toString(),
    Quantity: quantity,
    OMSId: baseOptions.OMSId,
    LockedIn: formValues.lockedIn,
    Timestamp: Date.now()
  };
};
var getFormValuesForBuySellForm = function getFormValuesForBuySellForm(baseOptions, options) {
  var form = options.form,
    state = options.state;
  var roundBuyLimitPrices = _config["default"].RetailBuySell.roundBuyLimitPrices;
  var formValues = form;
  var selectedValues = (0, _buySellSelectors.getOrderFormInfoSelector)(state);
  var buy = !Number(formValues.side);
  var Value = (0, _numberFormatter.truncateToDecimals)(selectedValues.price, options.priceDecimalPlaces, roundBuyLimitPrices && buy ? _bignumber["default"].ROUND_CEIL : null).toNumber();
  return _objectSpread(_objectSpread({}, baseOptions), {}, {
    TimeInForce: _timeInForceConstants.timeInForceForOrderType['Good till Cancel'],
    Side: Number(formValues.side),
    OrderType: Number(_orderEntryFormConstants.orderTypes.market.orderType),
    Value: Value
  });
};
var getTimeInForceValue = function getTimeInForceValue(orderType) {
  var timeInForceValue = 1;
  if (_timeInForceConstants.timeInForceForOrderType[orderType] !== undefined) {
    timeInForceValue = _timeInForceConstants.timeInForceForOrderType[orderType];
  }
  return timeInForceValue;
};
var getPegPriceByType = exports.getPegPriceByType = function getPegPriceByType(level1, form) {
  var level1ForInstrument = level1[form.instrument];
  if (form.pegPriceType === _pegPriceTypeConstants.pegPriceType.ask) {
    return level1ForInstrument.BestOffer;
  } else if (form.pegPriceType === _pegPriceTypeConstants.pegPriceType.bid) {
    return level1ForInstrument.BestBid;
  } else if (form.pegPriceType === _pegPriceTypeConstants.pegPriceType.last) {
    return level1ForInstrument.LastTradedPx;
  }
};
var getPegPriceTypeBySide = function getPegPriceTypeBySide(side) {
  return side === _orderEntryFormConstants.buyValue ? _pegPriceTypeConstants.pegPriceType.ask : _pegPriceTypeConstants.pegPriceType.bid;
};